import React from 'react';
import DefaultDrawer from '../../defaultDrawer/DefaultDrawer';
import { useModal } from '../../../../../contexts/modalsContext/modalsContext';
import SearchRidesForm from '../../../../pages/search/components/searchRidesForm/SearchRidesForm';
import './TicketSearchFormDrawer.scss';
import useWindowDimensions from '../../../../../hooks/useWindowDimensions';

function TicketSearchFormDrawer({
  seatFormationForm, rideSearchForm, chosenRides, guid,
}) {
  const { showTicketSearchDrawer, setShowTicketSearchDrawer } = useModal();
  const { width } = useWindowDimensions();
  return (
    <DefaultDrawer
      show={showTicketSearchDrawer && width < 1024}
      setShow={setShowTicketSearchDrawer}
      className="ticket-search-drawer"
    >
      <SearchRidesForm
        seatFormationForm={seatFormationForm}
        rideSearchForm={rideSearchForm}
        chosenRides={chosenRides}
        guid={guid}
      />
    </DefaultDrawer>
  );
}

export default TicketSearchFormDrawer;
